import { Icon, Button } from 'antd';
import AfspLoginCode403 from '../codes/AfspLoginCode403';
import AfspLoginCode455 from '../codes/AfspLoginCode455';
import AfspLoginCode456 from '../codes/AfspLoginCode456';
import AfspLoginCode457 from '../codes/AfspLoginCode457';
import AfspLoginCode458 from '../codes/AfspLoginCode458';
import AfspLoginCode459 from '../codes/AfspLoginCode459';
import AfspLoginCode460 from '../codes/AfspLoginCode460';
import { passwordReset as config } from '../forms/formConfig';
import { ssFormUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ key } = config,
{ generateInitState } = ssFormUtils;

export class LoginPending extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div className='afsp-login-indicator-status'>
                <div style={{ textAlign: 'center' }}>
                    <Icon type='loading' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'Logging in, please wait...'}
                    </span>
                </div>
            </div>
        );
    }
}

export class LoginSuccess extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div className='afsp-login-indicator-status-transparent'>
                <div className='afsp-login-indicator-status'>
                    <div style={{ textAlign: 'center' }}>
                        <Icon type='check-circle' style={{ fontSize: '20px', marginRight: '10px' }} />
                        <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                            {'Log-in successful! Redirecting, please wait...'}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export class LoginFailure extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { services, state: { login: { loginRequest: { code }}}} = this.props;
        switch(code) {
            case 403: return <AfspLoginCode403 {...this.props} />;
            case 455: return <AfspLoginCode455 {...this.props} />;
            case 456: return <AfspLoginCode456 {...this.props} />;
            case 457: return <AfspLoginCode457 {...this.props} />;
            case 458: return <AfspLoginCode458 {...this.props} />;
            case 459: return <AfspLoginCode459 {...this.props} />;
            case 460: return <AfspLoginCode460 {...this.props} />;
            default: return (
                <div className='afsp-login-indicator-status-error'>
                    <div style={{
                        position: 'absolute',
                        transform: 'translateX(-50%) translateY(-50%)',
                        left: '50%',
                        top: '40%',
                        width: '273px'
                    }}>
                        <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                        <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                            {'Unknown error. Unable to log in.'}
                        </span>
                    </div>
                    <Button
                        size='small'
                        icon='rollback'
                        type='primary'
                        style={{
                            width: '120px',
                            borderRadius: '20px',
                            position: 'absolute',
                            transform: 'translateX(-50%) translateY(-50%)',
                            left: '50%',
                            top: '70%'
                        }}
                        onClick={() => {
                            services.toggleAfspLoginStatusModal();
                            services.resetAfspLoginRequest();
                        }}
                    >
                        {'Retry'}
                    </Button>
                </div>
            );
        }
    }
}

export class PasswordResetPending extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div style={{ textAlign: 'center', margin: '30px 0px 40px 0px' }}>
                <Icon type='loading' style={{ fontSize: '20px', marginRight: '10px' }} />
                <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                    {'Requesting reset, please wait...'}
                </span>
            </div>
        )
    }
}

export class PasswordResetSuccess extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div style={{ textAlign: 'center', margin: '30px 0px 40px 0px' }}>
                <div style={{ marginBottom: '10px' }}>
                    <Icon type='mail' style={{ fontSize: '40px' }} />
                </div>
                <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                    {'Reset request sent.'}
                </span>
            </div>
        )
    }
}

export class PasswordResetFailure extends React.Component {
    constructor(props) { super(props); }

    resetForm() {
        const { services: { storeForm }} = this.props;
        storeForm(key, generateInitState(config));
    }

    render() {
        const { services, state: { login: { loginButtonDisabled }}} = this.props;
        return (
            <div style={{ textAlign: 'center', margin: '30px 0px 40px 0px' }}>
                <div style={{ marginBottom: '10px' }}>
                    <Icon type='frown' style={{ fontSize: '40px' }} />
                </div>
                <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                    {'Unable to request a reset.'}
                </span>
                <div style={{ marginTop: '5px' }}>
                    <Button
                        size='small'
                        type='primary'
                        icon='rollback'
                        style={{ width: '180px', borderRadius: '5px' }}
                        onClick={() => {
                            if (!loginButtonDisabled) services.toggleAfspLoginButtonDisable();
                            services.resetCaptchaValidation();
                            services.resetAfspPasswordResetRequest();
                            this.resetForm();
                        }}
                    >
                        {'Retry'}
                    </Button>
                </div>
            </div>
        )
    }
}
